import React from 'react';
import './backup.css'


function backup () {
    
        return (
            <div>
                    <div className="container-fluid">

    <div className="row justify-content-center">

        {/* <!-- COL-SM-10 --> */}
        <div className="">

            <div className="backupPageWrapper">

                <div className="backupPageContainer">

                    {/* <!-- HEADER --> */}
                    <div className="backupHeaderContainer">

                        <div className="backupTitleArea">

                            <div className="backupMainTitle">
                                Sao lưu dữ liệu
                            </div>

                            <div className="backupBreadcrumbText">
                                Trang chủ / Sao lưu dữ liệu / Sao lưu dữ liệu
                            </div>

                        </div>

                        <button className="backupCreateButton">
                            ＋ Tạo sao lưu mới
                        </button>

                    </div>

                    {/* <!-- SEARCH --> */}
                    <div className='backupFilterRow'>
                    <div className="backupSearchTitle">
                        Tìm kiếm
                    </div>

                    <div className="row ">

                        {/* <!-- DATE --> */}
                        <div className="col-md-5 backupFilterGroup">

                            <label className="backupFilterLabel">
                                Thời gian sao lưu
                            </label>

                            <div className="backupDateRangeWrapper">

                                <div className="backupDateInputBox">

                                    <input
                                        type="text"
                                        className="backupDateInputField"
                                        placeholder="Từ ngày"
                                    />

                                    <div className="backupDateIcon">
                                        📅
                                    </div>

                                </div>

                                <div className="backupDateArrow">
                                    →
                                </div>

                                <div className="backupDateInputBoxRight">

                                    <input
                                        type="text"
                                        className="backupDateInputField"
                                        placeholder="Đến ngày"
                                    />

                                    <div className="backupDateIcon">
                                        📅
                                    </div>

                                </div>

                            </div>

                        </div>

                        {/* <!-- TYPE --> */}
                        <div className="col-md-2 backup-filter-group">

                            <label className="backupFilterLabel">
                                Loại sao lưu
                            </label>

                            <select className="backupSelectField">
                                <option>-- Tất cả --</option>
                            </select>

                        </div>

                        {/* <!-- STATUS --> */}
                        <div className="col-md-2 backup-filter-group-status">

                            <label className="backupFilterLabel">
                                Trạng thái
                            </label>

                            <select className="backupSelectField">
                                <option>-- Tất cả --</option>
                            </select>

                        </div>
{/* 
                        <!-- USER --> */}
                        <div className="col-md-3 backup-filter-group-who">

                            <label className="backupFilterLabel">
                                Người thực hiện
                            </label>

                            <div className="backupSearchInputWrapper">

                                <input
                                    type="text"
                                    className="backup-search-input-field"
                                    placeholder="Nhập tên người thực hiện..."
                                />

                                <div className="backupSearchIcon">
                                    🔍
                                </div>

                            </div>

                        </div>

                   

                    </div>

                    <div className='row'>
                        <div className='col-sm-12'>
     {/* <!-- ACTION --> */}
                        

                            <div className="backupActionButtonContainer">

                                <button className="backupResetButton">
                                    <i className="fa-solid fa-rotate icon-backup-rotage"></i>
                                    Đặt lại
                                </button>

                                <button className="backupSearchButton">
                                    🔍 Tìm kiếm
                                </button>

                            </div>

                        
                        </div>
                    </div>
                    </div>



                    {/* <!-- TABLE --> */}
                     
                    <div className="backupTableSection">

                        <div className="backupTableHeader">

                           <div className="backupTableTitle">
                                Danh sách bản sao lưu
                            </div>

                            <div className="backupTableActionGroup">

                                <button className="backupRunButton">
                                    ☁ Sao lưu ngay
                                </button>

                                <button className="backupDeleteButton">
                                    🗑 Xóa
                                </button>

                                <button className="backupSettingButton">
                                    ⚙
                                </button>

                            </div>

                        </div>

                        {/* <!-- TABLE --> */}
                        <div className="backupTableWrapper">

                            <table className="backupDataTable">

                                <thead className="backupTableHead">

                                    <tr className="backupTableHeadRow">

                                        <th className="backupTableHeadCell">STT</th>
                                        <th className="backupTableHeadCell">Tên bản sao lưu</th>
                                        <th className="backupTableHeadCell">Loại sao lưu</th>
                                        <th className="backupTableHeadCell">Thời gian bắt đầu</th>
                                        <th className="backupTableHeadCell">Thời gian kết thúc</th>
                                        <th className="backupTableHeadCell">Dung lượng</th>
                                        <th className="backupTableHeadCell">Người thực hiện</th>
                                        <th className="backupTableHeadCell">Trạng thái</th>
                                        <th className="backupTableHeadCell">Mô tả</th>
                                        <th className="backupTableHeadCell">Thao tác</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr className="backupTableBodyRow">
                                        <td className="backupTableBodyCell">1</td>
                                        <td className="backupTableBodyCell">Backup_20240520_0230</td>
                                        <td className="backupTableBodyCell">Tự động</td>
                                        <td className="backupTableBodyCell">20/05/2024 02:30:15</td>
                                        <td className="backupTableBodyCell">20/05/2024 02:32:45</td>
                                        <td className="backupTableBodyCell">256.45 MB</td>
                                        <td className="backupTableBodyCell">system</td>
                                        <td className="backupTableBodyCell">
                                            <span className="backupSuccessStatus">
                                                Thành công
                                            </span>
                                        </td>
                                        <td className="backupTableBodyCell">
                                            Sao lưu tự động hàng ngày
                                        </td>
                                         <td className="backupTableBodyCell">
                                            <div className="backupActionIconGroup">
                                                <span className="backupDownloadIcon">
                                                    <i className="fa-solid fa-download"></i>
                                                </span>
                                                <span className="backupRestoreIcon">
                                                    <i className="fa-solid fa-rotate"></i>
                                                </span>
                                                <span className="backupDeleteIcon">
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr className="backupTableBodyRow">
                                        <td className="backupTableBodyCell">2</td>
                                        <td className="backupTableBodyCell">Backup_20240519_0230</td>
                                        <td className="backupTableBodyCell">Tự động</td>
                                        <td className="backupTableBodyCell">19/05/2024 02:30:11</td>
                                        <td className="backupTableBodyCell">19/05/2024 02:32:20</td>
                                        <td className="backupTableBodyCell">254.12 MB</td>
                                        <td className="backupTableBodyCell">system</td>
                                        <td className="backupTableBodyCell">
                                            <span className="backupSuccessStatus">
                                                Thành công
                                            </span>
                                        </td>
                                        <td className="backupTableBodyCell">
                                            Sao lưu tự động hàng ngày
                                        </td>
                                         <td className="backupTableBodyCell">
                                            <div className="backupActionIconGroup">
                                                <span className="backupDownloadIcon">
                                                    <i className="fa-solid fa-download"></i>
                                                </span>
                                                <span className="backupRestoreIcon">
                                                    <i className="fa-solid fa-rotate"></i>
                                                </span>
                                                <span className="backupDeleteIcon">
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr className="backupTableBodyRow">
                                        <td className="backupTableBodyCell">3</td>
                                        <td className="backupTableBodyCell">Backup_20240518_0230</td>
                                        <td className="backupTableBodyCell">Tự động</td>
                                        <td className="backupTableBodyCell">18/05/2024 02:30:13</td>
                                        <td className="backupTableBodyCell">18/05/2024 02:32:19</td>
                                        <td className="backupTableBodyCell">255.01 MB</td>
                                        <td className="backupTableBodyCell">system</td>
                                        <td className="backupTableBodyCell">
                                            <span className="backupSuccessStatus">
                                                Thành công
                                            </span>
                                        </td>
                                        <td className="backupTableBodyCell">
                                            Sao lưu tự động hàng ngày
                                        </td>
                                         <td className="backupTableBodyCell">
                                            <div className="backupActionIconGroup">
                                                <span className="backupDownloadIcon">
                                                    <i className="fa-solid fa-download"></i>
                                                </span>
                                                <span className="backupRestoreIcon">
                                                    <i className="fa-solid fa-rotate"></i>
                                                </span>
                                                <span className="backupDeleteIcon">
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr className="backupTableBodyRow">
                                        <td className="backupTableBodyCell">4</td>
                                        <td className="backupTableBodyCell">Backup_20240517_0900</td>
                                        <td className="backupTableBodyCell">Thủ công</td>
                                        <td className="backupTableBodyCell">17/05/2024 09:00:05</td>
                                        <td className="backupTableBodyCell">17/05/2024 09:02:33</td>
                                        <td className="backupTableBodyCell">312.67 MB</td>
                                        <td className="backupTableBodyCell">admin</td>
                                        <td className="backupTableBodyCell">
                                            <span className="backupSuccessStatus">
                                                Thành công
                                            </span>
                                        </td>
                                        <td className="backupTableBodyCell">
                                            Sao lưu trước khi cập nhật hệ thống
                                        </td>
                                        <td className="backupTableBodyCell">
                                            <div className="backupActionIconGroup">
                                                <span className="backupDownloadIcon">
                                                    <i className="fa-solid fa-download"></i>
                                                </span>
                                                <span className="backupRestoreIcon">
                                                    <i className="fa-solid fa-rotate"></i>
                                                </span>
                                                <span className="backupDeleteIcon">
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr className="backupTableBodyRow">
                                        <td className="backupTableBodyCell">5</td>
                                        <td className="backupTableBodyCell">Backup_20240516_0230</td>
                                        <td className="backupTableBodyCell">Tự động</td>
                                        <td className="backupTableBodyCell">16/05/2024 02:30:12</td>
                                        <td className="backupTableBodyCell">16/05/2024 02:32:18</td>
                                        <td className="backupTableBodyCell">253.89 MB</td>
                                        <td className="backupTableBodyCell">system</td>
                                        <td className="backupTableBodyCell">
                                            <span className="backupSuccessStatus">
                                                Thành công
                                            </span>
                                        </td>
                                        <td className="backupTableBodyCell">
                                            Sao lưu tự động hàng ngày
                                        </td>
                                         <td className="backupTableBodyCell">
                                            <div className="backupActionIconGroup">
                                                <span className="backupDownloadIcon">
                                                    <i className="fa-solid fa-download"></i>
                                                </span>
                                                <span className="backupRestoreIcon">
                                                    <i className="fa-solid fa-rotate"></i>
                                                </span>
                                                <span className="backupDeleteIcon">
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr className="backupTableBodyRow">
                                        <td className="backupTableBodyCell">6</td>
                                        <td className="backupTableBodyCell">Backup_20240515_0230</td>
                                        <td className="backupTableBodyCell">Tự động</td>
                                        <td className="backupTableBodyCell">15/05/2024 02:30:14</td>
                                        <td className="backupTableBodyCell">15/05/2024 02:32:11</td>
                                        <td className="backupTableBodyCell">252.75 MB</td>
                                        <td className="backupTableBodyCell">system</td>
                                        <td className="backupTableBodyCell">
                                            <span className="backupSuccessStatus">
                                                Thành công
                                            </span>
                                        </td>
                                        <td className="backupTableBodyCell">
                                            Sao lưu tự động hàng ngày
                                        </td>
                                         <td className="backupTableBodyCell">
                                            <div className="backupActionIconGroup">
                                                <span className="backupDownloadIcon">
                                                    <i className="fa-solid fa-download"></i>
                                                </span>
                                                <span className="backupRestoreIcon">
                                                    <i className="fa-solid fa-rotate"></i>
                                                </span>
                                                <span className="backupDeleteIcon">
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr className="backupTableBodyRow">
                                        <td className="backupTableBodyCell">7</td>
                                        <td className="backupTableBodyCell">Backup_20240514_0230</td>
                                        <td className="backupTableBodyCell">Tự động</td>
                                        <td className="backupTableBodyCell">14/05/2024 02:30:10</td>
                                        <td className="backupTableBodyCell">14/05/2024 02:32:17</td>
                                        <td className="backupTableBodyCell">251.33 MB</td>
                                        <td className="backupTableBodyCell">system</td>
                                        <td className="backupTableBodyCell">
                                            <span className="backupSuccessStatus">
                                                Thành công
                                            </span>
                                        </td>
                                        <td className="backupTableBodyCell">
                                            Sao lưu tự động hàng ngày
                                        </td>
                                         <td className="backupTableBodyCell">
                                            <div className="backupActionIconGroup">
                                                <span className="backupDownloadIcon">
                                                    <i className="fa-solid fa-download"></i>
                                                </span>
                                                <span className="backupRestoreIcon">
                                                    <i className="fa-solid fa-rotate"></i>
                                                </span>
                                                <span className="backupDeleteIcon">
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr className="backupTableBodyRow">
                                        <td className="backupTableBodyCell">8</td>
                                        <td className="backupTableBodyCell">Backup_20240513_0230</td>
                                        <td className="backupTableBodyCell">Tự động</td>
                                        <td className="backupTableBodyCell">13/05/2024 02:30:09</td>
                                        <td className="backupTableBodyCell">13/05/2024 02:32:15</td>
                                        <td className="backupTableBodyCell">250.88 MB</td>
                                        <td className="backupTableBodyCell">system</td>
                                        <td className="backupTableBodyCell">
                                            <span className="backupSuccessStatus">
                                                Thành công
                                            </span>
                                        </td>
                                        <td className="backupTableBodyCell">
                                            Sao lưu tự động hàng ngày
                                        </td>
                                         <td className="backupTableBodyCell">
                                            <div className="backupActionIconGroup">
                                                <span className="backupDownloadIcon">
                                                    <i className="fa-solid fa-download"></i>
                                                </span>
                                                <span className="backupRestoreIcon">
                                                    <i className="fa-solid fa-rotate"></i>
                                                </span>
                                                <span className="backupDeleteIcon">
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr className="backupTableBodyRow">
                                        <td className="backupTableBodyCell">9</td>
                                        <td className="backupTableBodyCell">Backup_20240512_1100</td>
                                        <td className="backupTableBodyCell">Thủ công</td>
                                        <td className="backupTableBodyCell">12/05/2024 11:00:22</td>
                                        <td className="backupTableBodyCell">12/05/2024 11:03:05</td>
                                        <td className="backupTableBodyCell">318.44 MB</td>
                                        <td className="backupTableBodyCell">nguyenvana</td>
                                        <td className="backupTableBodyCell">
                                            <span className="backupErrorStatus">
                                                Thất bại
                                            </span>
                                        </td>
                                        <td className="backupTableBodyCell">
                                            Sao lưu theo yêu cầu
                                        </td>
                                        <td className="backupTableBodyCell">
                                            <div className="backupActionIconGroup">
                                                <span className="backupDownloadIcon">
                                                    <i className="fa-solid fa-download"></i>
                                                </span>
                                                <span className="backupRestoreIcon">
                                                    <i className="fa-solid fa-rotate"></i>
                                                </span>
                                                <span className="backupDeleteIcon">
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr className="backupTableBodyRow">
                                        <td className="backupTableBodyCell">10</td>
                                        <td className="backupTableBodyCell">Backup_20240511_0230</td>
                                        <td className="backupTableBodyCell">Tự động</td>
                                        <td className="backupTableBodyCell">11/05/2024 02:30:12</td>
                                        <td className="backupTableBodyCell">11/05/2024 02:32:20</td>
                                        <td className="backupTableBodyCell">249.76 MB</td>
                                        <td className="backupTableBodyCell">system</td>
                                        <td className="backupTableBodyCell">
                                            <span className="backupSuccessStatus">
                                                Thành công
                                            </span>
                                        </td>
                                        <td className="backupTableBodyCell">
                                            Sao lưu tự động hàng ngày
                                        </td>
                                        <td className="backupTableBodyCell">
                                            <div className="backupActionIconGroup">
                                                <span className="backupDownloadIcon">
                                                    <i className="fa-solid fa-download"></i>
                                                </span>
                                                <span className="backupRestoreIcon">
                                                    <i className="fa-solid fa-rotate"></i>
                                                </span>
                                                <span className="backupDeleteIcon">
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>

                                </tbody>

                            </table>

                        </div>

                        {/* <!-- PAGINATION --> */}
                        <div className="backupPaginationContainer">

                            <div className="backupPaginationLeft">

                                <div className="backupPaginationText">
                                    Hiển thị
                                </div>

                                <select className="backupPaginationSelect">
                                    <option>10</option>
                                </select>

                                <div className="backupPaginationText">
                                    dòng trên mỗi trang
                                </div>

                            </div>

                            <div className="backupPaginationRight">
                                <div className='number-in-share'>
                                    1-10 trong 28
                                </div>

                                <button className="backupPaginationButton">
                                    «
                                </button>

                                <button className="backupPaginationButton">
                                    ‹
                                </button>

                                <button className="backupPaginationButtonActive">
                                    1
                                </button>

                                <button className="backupPaginationButton">
                                    2
                                </button>

                                <button className="backupPaginationButton">
                                    3
                                </button>

                                <button className="backupPaginationButton">
                                    ›
                                </button>

                                <button className="backupPaginationButton">
                                    »
                                </button>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>
            </div>
        );
    
}



export default backup;